import React from "react";
import { Button, SimpleGrid } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { BsArrowClockwise, BsPlusLg } from "react-icons/bs";
import RiskReviewPageShell from "../components/common/RiskReviewPageShell";
import RiskReviewLoadingState from "../components/common/RiskReviewLoadingState";
import RiskReviewErrorState from "../components/common/RiskReviewErrorState";
import RiskReviewStatsGrid from "../components/dashboard/RiskReviewStatsGrid";
import RiskReviewStatusChart from "../components/dashboard/RiskReviewStatusChart";
import RiskReviewMonthlyChart from "../components/dashboard/RiskReviewMonthlyChart";
import { useRiskReviewDashboard } from "../hooks/useRiskReviewDashboard";

const RiskReviewDashboardPage = () => {
  const query = useRiskReviewDashboard();
  const stats = query.data || {};

  return (
    <RiskReviewPageShell
      title="Risk Review Management"
      description="Monitor request volumes, approvals, risks and review progress."
      actions={
        <>
          <Button size="sm" variant="outline" leftIcon={<BsArrowClockwise />} onClick={() => query.refetch()}>
            Refresh
          </Button>
          <Button as={RouterLink} to="/risk-review/requests/new" size="sm" colorScheme="blue" leftIcon={<BsPlusLg />}>
            Create Risk Review
          </Button>
        </>
      }
    >
      {query.isLoading ? <RiskReviewLoadingState /> : null}
      {query.isError ? <RiskReviewErrorState error={query.error} onRetry={query.refetch} /> : null}
      {query.isSuccess ? (
        <>
          <RiskReviewStatsGrid stats={stats} />
          <SimpleGrid columns={{ base: 1, xl: 2 }} spacing={4}>
            {Array.isArray(stats.monthlyCompletion) ? <RiskReviewMonthlyChart data={stats.monthlyCompletion} /> : null}
            <RiskReviewStatusChart byStatus={stats.byStatus} />
          </SimpleGrid>
        </>
      ) : null}
    </RiskReviewPageShell>
  );
};

export default RiskReviewDashboardPage;
